<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content"
      :class="{'section-loading': isLoading}">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <h4 class="modal-title">拜訪紀錄(舊)</h4>
        </div>
        <div class="modal-body"
        v-if="tableData.length > 0">
          <table class="table insurance-green">
            <thead>
              <tr>
                <th width="15%">拜訪日期</th>
                <th width="25%">拜訪項目</th>
                <th>拜訪狀況</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in tableData"
              :key="`row-data-${i}`">
                <td>{{row.visit_day | dateFormat}}</td>
                <td>
                  <div v-for="(csita, a) in row.csitema"
                  :key="`csitema-${a}`">{{csita}}<br></div>
                  <div v-for="(csitb, b) in row.csitemb"
                  :key="`csitemb-${b}`">{{csitb}}<br></div>
                  <div v-for="(csitc, c) in row.csitemc"
                  :key="`csitemc-${c}`">{{csitc}}<br></div>
                  <div>{{row.csitemd}}</div>
                  <!-- 拜訪項目1: {{row.csitema}}<br>拜訪項目2: {{row.csitemb}}<br>拜訪項目3: {{row.csitemc}}<br>拜訪項目4: {{row.csitemd}} -->
                  </td>
                <td>{{row.coalesce}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="modal-body">
          <h4 class=" text-center">無任何拜訪紀錄</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {commonMixin} from '@/mixins/common'

export default {
  name: 'VisitModal',
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    visit_data: {
      type: Array,
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {  //data block layout
    return {
      tableData: []
    }  
  },
  watch:  {
    visit_data(val) {
      this.tableData = val;
    }
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    
  },
  mounted() {
    
  }
}
</script>
